<!-- Dispatches a submitted chat form answer to the type-specific answer display component. -->

<script lang="ts" setup>
import type { Json } from '@nzyme/utils/toJson.js';

import type { FormInputConfig, FormInputValue } from '@sigma/common/forms/FormInput.js';
import type { MultiSelectInputConfig } from '@sigma/common/forms/MultiSelectInput.js';
import type { ScaleInputConfig } from '@sigma/common/forms/ScaleInput.js';

import ChatBirthDateAnswer from './ChatBirthDateAnswer.vue';
import ChatBloodPressureAnswer from './ChatBloodPressureAnswer.vue';
import ChatGenderAnswer from './ChatGenderAnswer.vue';
import ChatMultiSelectAnswer from './ChatMultiSelectAnswer.vue';
import ChatScalarMeasurementAnswer from './ChatScalarMeasurementAnswer.vue';
import ChatScaleAnswer from './ChatScaleAnswer.vue';
import ChatSingleSelectAnswer from './ChatSingleSelectAnswer.vue';
import ChatTextAnswer from './ChatTextAnswer.vue';

interface Props {
  /** The input config from the corresponding AGENT_QUESTION event. */
  config: FormInputConfig;
  /** The answer value from the PATIENT_ANSWER event. */
  value: Json<FormInputValue>;
}

defineProps<Props>();
</script>

<template>
  <ChatSingleSelectAnswer
    v-if="value.type === 'SINGLE_SELECT'"
    :value="value"
  />
  <ChatMultiSelectAnswer
    v-else-if="value.type === 'MULTI_SELECT'"
    :config="config as MultiSelectInputConfig"
    :value="value"
  />
  <ChatTextAnswer
    v-else-if="value.type === 'TEXT'"
    :value="value"
  />
  <ChatScaleAnswer
    v-else-if="value.type === 'SCALE'"
    :config="config as ScaleInputConfig"
    :value="value"
  />
  <ChatBirthDateAnswer
    v-else-if="value.type === 'BIRTH_DATE'"
    :value="value"
  />
  <ChatGenderAnswer
    v-else-if="value.type === 'GENDER'"
    :value="value"
  />
  <ChatScalarMeasurementAnswer
    v-else-if="value.type === 'MEASUREMENT'"
    :value="value"
  />
  <ChatBloodPressureAnswer
    v-else-if="value.type === 'BLOOD_PRESSURE'"
    :value="value"
  />
</template>
